<template>
    <card>
        <card-header>
            <card-overline>Unbestätigte P-Bestellungen</card-overline>
        </card-header>
        <card-content>
            <table class="table table--stripped table--card">
                <thead>
                <tr>
                    <th>
                        PF-Nr
                    </th>
                    <th>
                        Prod.-Nr
                    </th>
                    <th>
                        Prod.-Firma
                    </th>
                    <th>
                        Kunde
                    </th>
                    <th class="text-right">
                        Bestelldatum
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="upoAskForQuote in unconfirmedProducerOrderAskForQuotesTable" :key="upoAskForQuote.index">
                    <td>
                        <Link
                            :href="$$route('ask-for-quote', {'askForQuote': upoAskForQuote.id} )">
                            {{ upoAskForQuote.pfnumber }}
                        </Link>
                    </td>
                    <td>{{ upoAskForQuote.producer_order.producer_user.prod_no }}</td>
                    <td>{{ upoAskForQuote.producer_order.producer_user.company }}</td>
                    <td>{{ upoAskForQuote.client_user.company }}</td>

                    <td class="text-right">{{ upoAskForQuote.producer_order.created_at_string }}</td>
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
export default {
    name: 'UnconfirmedProducerOrders',
    components: {CardContent, CardOverline, CardHeader, Card},
    props: {
        unconfirmedProducerOrderAskForQuotes: Object,
    },
    computed: {
        unconfirmedProducerOrderAskForQuotesTable() {

            let askForQuotes = Array;

            return Object.keys(this?.unconfirmedProducerOrderAskForQuotes).map(key => {
                askForQuotes[key] = this.unconfirmedProducerOrderAskForQuotes[key];
                askForQuotes[key].created_at_string = this.$date(askForQuotes[key].created_at);
                askForQuotes[key].producer_order.created_at_string = this.$date(askForQuotes[key].producer_order.created_at);

                let lotQty = [];
                lotQty.push(askForQuotes[key].lotqty_1, askForQuotes[key].lotqty_2, askForQuotes[key].lotqty_3, askForQuotes[key].lotqty_4);
                askForQuotes[key].lot_qty = lotQty.filter(lot => lot !== null).join(', ');

                return askForQuotes[key];
            });
        },
    },
};
</script>
